import { FC, PropsWithChildren } from 'react';

import { createPortal } from 'react-dom';

import { logger } from '@/utils/logger/logger';

interface PortalProps extends PropsWithChildren {
  target: string;
}

export const Portal: FC<PortalProps> = ({ target, children }) => {
  const targetElement = document.getElementById(target);
  if (!targetElement) {
    logger.warn('Portal:', `Target element '${target}' not found`);
    return null;
  }
  return createPortal(children, targetElement);
};
